
import AepsMiniMain from "../../components/aeps-mini-statement/AepsMiniMain"

export const AEPSMiniStatmentReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <AepsMiniMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}